import DisplayTotal from "./DisplayTotal.vue";
import FormHeader from "./FormHeader.vue";
import FormTable from "./FormTable.vue";
import ModalAssetLine from "./ModalAssetLine.vue";

export { DisplayTotal, FormHeader, FormTable, ModalAssetLine };
